export default import.meta.ROLLDOWN_FILE_URL_kXhaOeJa5Bqdy9ACgCD_Pg